import { useTranslation } from "hooks/useTranslation";
import Head from "layout/Head";
import React, { Fragment } from "react";
import { ModelCompareTab } from "../GettingStartedWithUniFi.types";
import { PhysicalSecurityOverview } from "constants/modelCompareData/data/PhysicalSecurityOverview";
import { ExtendedTabId } from "components/ExtendedTabs/ExtendedTabs.types";
import { WifiOverview } from "constants/modelCompareData/data/WiFiOverview";
import { SwitchingProfessional } from "constants/modelCompareData/data/SwitchingProfessional";
import { HowItWorksPage } from "components/HowItWorksPage";
import {
  DEPLOYMENT_HERO_CONFIG,
  MULTI_SITE_DEPLOYMENT_MOBILE_CONFIG,
  MULTI_SITE_DEPLOYMENT_SWITCHING_TAB,
} from "./MultiSiteDeployment.config";
import { MODEL_COMPARE_TABS } from "../shared.config";

import multiSiteRiv from "../assets/rive/multi-site.riv";
import multiSiteMobileRiv from "../assets/rive/multi-site-mobile.riv";

const MODEL_COMPARE_DATA_BY_ID = {
  [ModelCompareTab.Switching]: SwitchingProfessional,
  [ModelCompareTab.AccessPoints]: WifiOverview,
  [ModelCompareTab.Cameras]: PhysicalSecurityOverview,
  [ModelCompareTab.DoorAccess]: null,
};

export const MultiSiteDeployment = () => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <Head
        title={t("gettingStartedWithUniFi.seo.title")}
        description={t("gettingStartedWithUniFi.seo.description")}
        url="https://ui.com/how-it-works/multi-site"
        image="https://www.ui.com/microsite/og-image.png"
      />

      <HowItWorksPage
        hero={{
          title: "gettingStartedWithUniFi.hero.title",
          config: DEPLOYMENT_HERO_CONFIG,
          mobileConfig: MULTI_SITE_DEPLOYMENT_MOBILE_CONFIG,
          isSimpleHero: true,
        }}
        topology={{
          title: "gettingStartedWithUniFi.topology.intro.title",
          description: "gettingStartedWithUniFi.topology.intro.description",
          config: {
            src: multiSiteRiv,
          },
          mobileConfig: {
            src: multiSiteMobileRiv,
            aspectRatio: "432/1250",
          },
        }}
        activePageId={ExtendedTabId.MultiSiteDeployment}
        compareTabs={[
          MULTI_SITE_DEPLOYMENT_SWITCHING_TAB,
          ...MODEL_COMPARE_TABS,
        ]}
        compareOptions={MODEL_COMPARE_DATA_BY_ID}
      />
    </Fragment>
  );
};
